<template>
  <div class="gr-page">
    <div class="gr-page__container">
      <h1 class="gr-page__title">我的账户</h1>
      
      <div class="gr-page__tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="gr-page__tab"
          :class="{ 'gr-page__tab--active': activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          {{ tab.name }}
        </button>
      </div>

      <div class="gr-page__content">
        <!-- ==================== 我的账户 ==================== -->
        <div v-if="activeTab === 'account'" class="gr-page__section">
          <h2 class="gr-page__section-title">账户信息</h2>
          
          <div class="gr-page__form">
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">用户名</label>
              <input type="text" class="gr-page__form-input gr-page__form-input--full" v-model="accountForm.nicheng" placeholder="请输入用户名" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">电子邮箱</label>
              <input type="email" class="gr-page__form-input gr-page__form-input--full" v-model="accountForm.email" placeholder="请输入电子邮箱" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">手机号</label>
              <input type="tel" class="gr-page__form-input gr-page__form-input--full" v-model="accountForm.phone" placeholder="请输入手机号码" autocomplete="off" />
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">性别</label>
              <div class="gr-page__form-radio-group">
                <label class="gr-page__form-radio-label">
                  <input type="radio" name="gender" value="male" v-model="accountForm.gender" />
                  <span>男</span>
                </label>
                <label class="gr-page__form-radio-label">
                  <input type="radio" name="gender" value="female" v-model="accountForm.gender" />
                  <span>女</span>
                </label>
              </div>
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">地址</label>
              <input type="text" class="gr-page__form-input gr-page__form-input--full" v-model="accountForm.dizhi" placeholder="请输入详细地址" autocomplete="off" />
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">密码</label>
              <input type="password" class="gr-page__form-input" v-model="accountForm.pwd" placeholder="输入您的新密码（不修改请留空）" autocomplete="new-password" />
              <label class="gr-page__form-label">确认密码</label>
              <input type="password" class="gr-page__form-input" v-model="accountForm.pwdConfirm" placeholder="确认新密码" autocomplete="new-password" />
            </div>
            
            <div class="gr-page__form-row">
              <label class="gr-page__form-label">个人简介</label>
              <textarea class="gr-page__form-textarea" v-model="accountForm.content" placeholder="请输入个人简介（选填）" rows="3" autocomplete="off"></textarea>
            </div>
            
            <button class="gr-page__submit-btn" @click="saveAccount">保存</button>
          </div>
        </div>

        <!-- ==================== 我的会员 ==================== -->
        <div v-if="activeTab === 'subscription'" class="gr-page__section">
          <h2 class="gr-page__section-title">我的会员</h2>
          
          <div class="gr-page__subscription-card" :class="{ 'gr-page__subscription-card--vip': isVip, 'gr-page__subscription-card--normal': !isVip }">
            <div class="gr-page__subscription-info">
              <div class="gr-page__subscription-plan">{{ isVip ? 'VIP会员账户' : '普通账户' }}</div>
              <div v-if="isVip" class="gr-page__subscription-price">¥118.8 / 年</div>
              <div v-if="isVip" class="gr-page__subscription-billing">每月 ¥9.9</div>
              <div v-if="isVip" class="gr-page__subscription-expire">到期时间：{{ vipEndTime }}</div>
              <div v-if="!isVip" class="gr-page__subscription-benefits">
                <div class="gr-page__subscription-benefit">开通vip后可无限制畅听所有歌曲</div>
                <div class="gr-page__subscription-benefit">开通vip后可畅听无损音质</div>
                <div class="gr-page__subscription-benefit">开通vip后可观看全站MV</div>
              </div>
            </div>
            <div class="gr-page__subscription-status">
              <button v-if="isVip" class="gr-page__subscription-btn gr-page__subscription-btn--vip">已开通</button>
              <button v-else class="gr-page__subscription-btn gr-page__subscription-btn--normal" @click="goToVip">开通VIP</button>
            </div>
          </div>
          
          <div class="gr-page__subscription-features">
            <h3>会员权益</h3>
            <ul>
              <li>
                <svg class="gr-page__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 18V5l12-2v13"></path>
                  <circle cx="6" cy="18" r="3"></circle>
                  <circle cx="18" cy="16" r="3"></circle>
                </svg>
                <span>开通会员后，平台内所有曲库歌曲无收听限制，无需单独单曲付费、无试听时长截断。无论是热门流行单曲、均可完整播放，告别免费用户仅能试听片段、部分付费歌曲无法收听的限制，随时随地随心畅听完整曲目，不用再为单首歌曲额外充值。</span>
              </li>
              <li>
                <svg class="gr-page__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                  <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                  <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                </svg>
                <span>高清音质，支持无损、超高音质。细节层次清晰，搭配耳机、音响均可还原歌曲原生录制质感，杜绝杂音、压缩失真，沉浸式感受音乐原本的编曲与录制效果，给你专业级听歌听觉体验。</span>
              </li>
              <li>
                <svg class="gr-page__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
                <span>不受免费用户每日有限次切歌限制，播放过程中遇到不喜欢、不想继续听的曲目，可一键无限制切换下一首，随心更换歌单顺序、随机切歌、手动切歌，无需等待固定播放时长才能跳过，刷歌、找喜欢的曲目更加自由，听歌节奏完全由自己掌控。</span>
              </li>
              <li>
                <svg class="gr-page__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
                <span>完整开放平台全分类音乐资源，小众冷门、独家签约专辑、限定专题曲库全部开放，丰富听歌选择。</span>
              </li>
              <li>
                <svg class="gr-page__feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
                <span>更换设备无需重新整理歌单，走到哪听到哪，个人音乐收藏永久留存，跨设备无缝接续听歌进度。</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- ==================== 管理收藏 ==================== -->
        <div v-if="activeTab === 'favorites'" class="gr-page__section">
          <h2 class="gr-page__section-title">管理收藏</h2>
          
          <div class="gr-page__favorites-desc">
            <p>"我的收藏"功能让您可以快速访问您喜爱的歌曲和MV。</p>
          </div>
          
          <div v-if="favorites.length === 0" class="gr-page__favorites-empty">
            <p>暂无收藏内容</p>
          </div>
          
          <div v-else class="gr-page__favorites-container">
            <div class="gr-page__favorites-column">
              <h3 class="gr-page__favorites-column-title">收藏的歌曲</h3>
              <div class="gr-page__favorites-list">
                <div class="gr-page__favorites-item" v-for="(item, index) in songFavorites" :key="index" @click="goToItem(item)">
                  <img :src="item.image" :alt="item.music_name" class="gr-page__favorites-item-img" />
                  <span class="gr-page__favorites-item-name">{{ item.music_name }}</span>
                  <span class="gr-page__favorites-item-num">{{ item.singer }}</span>
                </div>
              </div>
            </div>
            <div class="gr-page__favorites-column">
              <h3 class="gr-page__favorites-column-title">收藏的MV</h3>
              <div class="gr-page__favorites-list">
                <div class="gr-page__favorites-item" v-for="(item, index) in mvFavorites" :key="index" @click="goToItem(item)">
                  <img :src="item.image" :alt="item.title" class="gr-page__favorites-item-img" />
                  <span class="gr-page__favorites-item-name">{{ item.title }}</span>
                  <span class="gr-page__favorites-item-num">{{ item.author }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ==================== 上传音乐 ==================== -->
        <div v-if="activeTab === 'upload'" class="gr-page__section">
          <h2 class="gr-page__section-title">上传音乐</h2>
            <!-- <div class="gr-page__upload-steps">
              <div class="gr-page__upload-step" :class="{ 'gr-page__upload-step--active': uploadStep >= 1 }">
                <span class="gr-page__upload-step-num">1</span>
                <span class="gr-page__upload-step-text">填写信息</span>
              </div>
              <div class="gr-page__upload-step-line"></div>
              <div class="gr-page__upload-step" :class="{ 'gr-page__upload-step--active': uploadStep >= 2 }">
                <span class="gr-page__upload-step-num">2</span>
                <span class="gr-page__upload-step-text">上传文件</span>
              </div>
              <div class="gr-page__upload-step-line"></div>
              <div class="gr-page__upload-step" :class="{ 'gr-page__upload-step--active': uploadStep >= 3 }">
                <span class="gr-page__upload-step-num">3</span>
                <span class="gr-page__upload-step-text">审核发布</span>
              </div>
            </div> -->
            
            <div class="gr-page__form gr-page__form--upload">
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">歌曲名称 <span class="gr-page__required">*</span></label>
                <input type="text" class="gr-page__form-input gr-page__form-input--full" v-model="uploadForm.songName" placeholder="请输入歌曲名称" />
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">歌手/演唱者 <span class="gr-page__required">*</span></label>
                <input type="text" class="gr-page__form-input gr-page__form-input--full" v-model="uploadForm.artist" placeholder="请输入歌手名称" />
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">专辑名称</label>
                <input type="text" class="gr-page__form-input gr-page__form-input--full" v-model="uploadForm.album" placeholder="请输入专辑名称（选填）" />
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">音乐风格 <span class="gr-page__required">*</span></label>
                <select class="gr-page__form-input gr-page__form-input--full gr-page__form-input--select" v-model="uploadForm.genre">
                  <option value="">请选择音乐风格</option>
                  <option v-for="genre in genres" :key="genre" :value="genre">{{ genre }}</option>
                </select>
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">歌曲歌词</label>
                <textarea class="gr-page__form-textarea" v-model="uploadForm.lyrics" placeholder="请输入歌曲歌词（选填）" rows="5"></textarea>
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">歌曲简介</label>
                <textarea class="gr-page__form-textarea" v-model="uploadForm.description" placeholder="请输入歌曲简介（选填），不超过500字" rows="3" maxlength="500"></textarea>
                <span class="gr-page__form-textarea-count">{{ uploadForm.description.length }}/500</span>
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">封面图片 <span class="gr-page__required">*</span></label>
                <div class="gr-page__upload-area" @click="selectCover">
                  <img v-if="uploadForm.coverPreview" :src="uploadForm.coverPreview" class="gr-page__upload-preview" />
                  <div v-else class="gr-page__upload-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                    <span>点击上传封面图片</span>
                    <span class="gr-page__upload-tip">支持 JPG、PNG 格式，建议尺寸 500x500</span>
                  </div>
                </div>
                <input type="file" ref="coverInput" class="gr-page__hidden-input" accept="image/jpeg,image/png" @change="handleCoverChange" />
              </div>
              
              <div class="gr-page__form-row">
                <label class="gr-page__form-label">音频文件 <span class="gr-page__required">*</span></label>
                <div class="gr-page__upload-area gr-page__upload-area--audio" @click="selectAudio">
                  <div v-if="uploadForm.audioName" class="gr-page__upload-audio-info">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                    </svg>
                    <span>{{ uploadForm.audioName }}</span>
                  </div>
                  <div v-else class="gr-page__upload-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M9 18V5l12-2v13"></path>
                      <circle cx="6" cy="18" r="3"></circle>
                      <circle cx="18" cy="16" r="3"></circle>
                    </svg>
                    <span>点击上传音频文件</span>
                    <span class="gr-page__upload-tip">支持 MP3、WAV、FLAC 格式，大小不超过 50MB</span>
                  </div>
                </div>
                <input type="file" ref="audioInput" class="gr-page__hidden-input" accept="audio/mp3,audio/wav,audio/flac,audio/mpeg" @change="handleAudioChange" />
              </div>
              <div class="gr-page__form-row">
                <input type="checkbox" id="copyright" class="gr-page__form-checkbox" />
                <label for="copyright" class="gr-page__form-checkbox-label">我保证拥有该音乐的完整版权，或已获得版权方授权</label>
              </div>
              <button class="gr-page__submit-btn" @click="submitUpload">提交审核</button>
            </div>
        </div>
      </div>
    </div>
    
    <div class="gr-page__modal-overlay" v-if="showUploadModal" @click="closeModal">
      <div class="gr-page__modal" @click.stop>
        <div class="gr-page__modal-header">
          <h3 class="gr-page__modal-title">提交审核</h3>
          <button class="gr-page__modal-close" @click="closeModal">×</button>
        </div>
        <div class="gr-page__modal-body">
          <div v-if="uploadProgress < 100">
            <div class="gr-page__modal-icon">⚡</div>
            <p class="gr-page__modal-text">{{ uploadStatus }}</p>
            <div class="gr-page__modal-progress-bar">
              <div class="gr-page__modal-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
            </div>
            <p class="gr-page__modal-progress-text">{{ Math.round(uploadProgress) }}%</p>
          </div>
          <div v-else>
            <div class="gr-page__modal-icon gr-page__modal-icon--success">✓</div>
            <p class="gr-page__modal-text gr-page__modal-text--success">提交成功！</p>
            <p class="gr-page__modal-subtext">您的音乐正在审核中，审核通过后将进入版权复核环节，完成后上线</p>
          </div>
        </div>
        <div class="gr-page__modal-footer">
          <button class="gr-page__modal-btn" v-if="uploadProgress >= 100" @click="closeModal">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Gr',
  data() {
    return {
      activeTab: 'account',
      tabs: [
          { id: 'account', name: '我的账户' },
          { id: 'subscription', name: '我的会员' },
          { id: 'favorites', name: '管理收藏' },
          { id: 'upload', name: '上传音乐' }
        ],
      accountForm: {
          nicheng: '',
          email: '',
          phone: '',
          gender: '',
          dizhi: '',
          pwd: '',
          pwdConfirm: '',
          content: ''
        },
        uploadForm: {
          songName: '',
          artist: '',
          album: '',
          genre: '',
          lyrics: '',
          description: '',
          coverFile: null,
          audioFile: null,
          coverPreview: '',
          audioName: ''
        },
        isVip: false,
        vipEndTime: '',
        uploadStep: 1,
      genres: ['流行', '摇滚', '爵士', '古典', '电子', '民谣', 'R&B', '嘻哈', '乡村', '蓝调', '金属', '其他'],
      uploadProgress: 0,
      uploadStatus: '',
      showUploadModal: false,
      favorites: [],
      availableChannels: [
        { name: '咖啡馆爵士乐', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=cafe%20jazz%20radio%20station%20cover%20art%20coffee%20cup%20vintage&image_size=square' },
        { name: '贝斯爵士', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=bass%20jazz%20radio%20station%20cover%20art%20bass%20guitar%20blue&image_size=square' },
        { name: '比波普', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=bebop%20jazz%20radio%20station%20cover%20art%20abstract%20colorful&image_size=square' },
        { name: '蓝调', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=blues%20jazz%20radio%20station%20cover%20art%20harmonica%20vintage&image_size=square' },
        { name: '蓝调摇滚', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=blues%20rock%20jazz%20radio%20station%20cover%20art%20electric%20guitar&image_size=square' },
        { name: '波萨诺瓦', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=bossa%20nova%20jazz%20radio%20station%20cover%20art%20brazilian%20beach&image_size=square' },
        { name: '经典爵士乐', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=classic%20jazz%20radio%20station%20cover%20art%20trumpet%20saxophone&image_size=square' },
        { name: '鸡尾酒爵士乐', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=cocktail%20jazz%20radio%20station%20cover%20art%20elegant%20bar&image_size=square' },
        { name: '当代爵士乐', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=contemporary%20jazz%20radio%20station%20cover%20art%20modern%20style&image_size=square' },
        { name: '酷派爵士', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=cool%20jazz%20radio%20station%20cover%20art%20smooth%20blue%20tones&image_size=square' },
        { name: '爵士吉他', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=jazz%20guitar%20radio%20station%20cover%20art%20acoustic%20guitar&image_size=square' },
        { name: '爵士古巴', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=jazz%20cuban%20radio%20station%20cover%20art%20cuban%20dance%20music&image_size=square' }
      ]
    }
  },
  computed: {
    songFavorites() {
      return this.favorites.filter(item => item.music_name)
    },
    mvFavorites() {
      return this.favorites.filter(item => item.title)
    }
  },
  created() {
    const tab = this.$route.query.tab
    if (tab && this.tabs.some(t => t.id === tab)) {
      this.activeTab = tab
    }
    this.loadFavorites()
    this.checkVipStatus()
  },
  mounted() {
    this.loadUserInfo()
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 'favorites') {
        this.loadFavorites()
      }
    }
  },
  methods: {
    // 加载用户信息到表单
    loadUserInfo() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) return

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) return

      // 填充表单数据，有对应字段就显示，没有就不填
      this.accountForm = {
        nicheng: userInfo.nicheng || '',
        email: userInfo.email || '',
        phone: userInfo.phone || '',
        gender: userInfo.gender === '男' ? 'male' : (userInfo.gender === '女' ? 'female' : ''),
        dizhi: userInfo.dizhi || '',
        pwd: '',
        pwdConfirm: '',
        content: userInfo.content || ''
      }
    },

    // 点击保存后更新本地存储和Vuex中的用户信息
    updateLocalUserInfo(form) {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) return

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) return

      // 更新用户信息（优先使用表单中的值，因为params可能做了转换）
      if (form.nicheng !== undefined) userInfo.nicheng = form.nicheng
      if (form.email !== undefined) userInfo.email = form.email
      if (form.phone !== undefined) userInfo.phone = form.phone
      // 性别需要转换回中文
      if (form.gender) userInfo.gender = form.gender === 'male' ? '男' : '女'
      if (form.dizhi !== undefined) userInfo.dizhi = form.dizhi
      if (form.content !== undefined) userInfo.content = form.content

      // 更新本地存储
      localStorage.setItem('YousrDL', JSON.stringify(userInfo))

      // 更新Vuex
      this.$store.commit('setUserInfo', userInfo)
    },

    loadFavorites() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) return

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) return

      const username = userInfo.username || ''
      if (!username) return

      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/shoucangs', { params: { username } })
        .then(response => {
          const data = response.data
          if (data.data) {
            this.favorites = data.data
          }
        })
        .catch(error => {
          console.error('获取收藏列表失败:', error)
        })
    },
    goToItem(item) {
      if (item.music_name) {
        this.$router.push({ path: '/xiangqing', query: { id: item.id } })
      } else if (item.title) {
        this.$router.push({ path: '/mvxq', query: { id: item.id } })
      }
    },
    checkVipStatus() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) {
        this.isVip = false
        return
      }

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) {
        this.isVip = false
        return
      }

      this.isVip = userInfo.isnovip == 1
      this.vipEndTime = '2027-7-15'
    },
    goToVip() {
      this.$router.push('/vip')
    },
    saveAccount() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) {
        alert('您还没有登录！')
        return
      }

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) {
        alert('获取用户信息失败')
        return
      }

      const username = userInfo.username || ''
      if (!username) {
        alert('获取用户信息失败')
        return
      }

      const form = this.accountForm

      if (form.phone && !/^1[3-9]\d{9}$/.test(form.phone)) {
        alert('请输入正确的手机号码')
        return
      }

      if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        alert('请输入正确的邮箱格式')
        return
      }

      if (form.pwd && form.pwd.length < 6) {
        alert('密码长度不能少于6位')
        return
      }

      if (form.pwd && form.pwd !== form.pwdConfirm) {
        alert('两次输入的密码不一致')
        return
      }

      const params = {
        username: username
      }

      if (form.phone) {
        params.phone = form.phone
      }

      if (form.email) {
        params.email = form.email
      }

      if (form.gender) {
        params.gender = form.gender === 'male' ? '男' : '女'
      }

      if (form.dizhi) {
        params.dizhi = form.dizhi
      }

      if (form.content) {
        params.content = form.content
      }

      if (form.pwd) {
        params.pwd = form.pwd
      }

      if (form.nicheng) {
        params.nicheng = form.nicheng
      }

      axios.post('https://xinyinyue.xiangyouhulian.cn/api/index/saveInfo', params)
        .then(response => {
          if (response.data.code === 200) {
            // 如果有修改密码，自动退出并跳转到首页
            if (form.pwd) {
              alert('密码修改成功，需要重新验证！')
              // 先跳转，再清除登录状态（避免组件渲染报错）
              this.$router.push('/')
              // 延迟清除登录状态
              setTimeout(() => {
                localStorage.removeItem('YousrDL')
                this.$store.commit('setUserInfo',[{id:0,image:'../assets/img-today-0364456e.png',username:'无'}])
              }, 100)
              return
            }
            
            // // 更新本地存储和Vuex中的用户信息（用户名等）
            this.updateLocalUserInfo(form)
            alert('保存成功')
          } else {
            alert(response.data.msg || '保存失败')
          }
        })
        .catch(error => {
          console.error('保存失败:', error)
          alert('保存失败，请稍后重试')
        })
    },
    selectCover() {
      this.$refs.coverInput.click();
    },
    handleCoverChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const allowedTypes = ['image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        alert('请上传 JPG 或 PNG 格式的图片');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过 5MB');
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.uploadForm.coverPreview = event.target.result;
        this.uploadForm.coverFile = file;
      };
      reader.readAsDataURL(file);
    },
    selectAudio() {
      this.$refs.audioInput.click();
    },
    handleAudioChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const allowedTypes = ['audio/mp3', 'audio/wav', 'audio/flac', 'audio/mpeg'];
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(mp3|wav|flac)$/i)) {
        alert('请上传 MP3、WAV 或 FLAC 格式的音频文件');
        return;
      }
      if (file.size > 50 * 1024 * 1024) {
        alert('音频文件大小不能超过 50MB');
        return;
      }
      this.uploadForm.audioFile = file;
      this.uploadForm.audioName = file.name;
    },
    submitUpload() {
      if (!this.uploadForm.songName) {
        alert('请输入歌曲名称');
        return;
      }
      if (!this.uploadForm.artist) {
        alert('请输入歌手/演唱者');
        return;
      }
      if (!this.uploadForm.genre) {
        alert('请选择音乐风格');
        return;
      }
      if (!this.uploadForm.coverFile) {
        alert('请上传封面图片');
        return;
      }
      if (!this.uploadForm.audioFile) {
        alert('请上传音频文件');
        return;
      }
      if (!document.getElementById('copyright').checked) {
        alert('请确认您拥有该音乐的版权');
        return;
      }
      this.showUploadModal = true;
      this.uploadStatus = '正在上传...';
      this.uploadProgress = 0;
      this.uploadStep = 2;
      const interval = setInterval(() => {
        this.uploadProgress += Math.random() * 15;
        if (this.uploadProgress >= 50) {
          this.uploadStatus = '正在处理音频...';
        }
        if (this.uploadProgress >= 80) {
          this.uploadStatus = '正在提交审核...';
        }
        if (this.uploadProgress >= 100) {
          clearInterval(interval);
          this.uploadProgress = 100;
          this.uploadStatus = '提交成功';
          this.uploadStep = 3;
        }
      }, 300);
    },
    closeModal() {
      this.showUploadModal = false;
      this.uploadProgress = 0;
      this.uploadStatus = '';
      this.uploadStep = 1;
      this.uploadForm = {
        songName: '',
        artist: '',
        album: '',
        genre: '',
        lyrics: '',
        description: '',
        coverFile: null,
        audioFile: null,
        coverPreview: '',
        audioName: ''
      };
    }
  }
}
</script>

<style scoped lang="scss">
.gr-page {
  width: 100%;
  min-height: calc(100vh - 80px);
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
  background-image: url('../../assets/gryh.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;

  &__container {
    position: relative;
    z-index: 1;
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 20px;
    box-sizing: border-box;
  }

  &__title {
    text-align: center;
    color: #ffffff;
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 30px 0;
    letter-spacing: 1px;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    background-color: #6b2a2a;
    border-radius: 4px 4px 0 0;
    padding: 0;
    margin: 0;
    list-style: none;
    flex-wrap: wrap;
  }

  &__tab {
    padding: 15px 20px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
    border-bottom: 3px solid transparent;

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }

    &--active {
      color: #ffffff;
      border-bottom-color: #f37021;
    }
  }

  &__content {
    background-color: #6b2a2a;
    border-radius: 0 0 4px 4px;
    padding: 30px;
  }

  &__section {
    color: #ffffff;
  }

  &__section-title {
    font-size: 16px;
    font-weight: 600;
    color: #f37021;
    margin: 0 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__form {
    margin-bottom: 30px;
  }

  &__form-row {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }

  &__form-label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    min-width: 60px;
  }

  &__form-input {
    flex: 1;
    min-width: 150px;
    padding: 10px 15px;
    background-color: #5c2525;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: rgba(255, 255, 255, 0.3);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }

    &--full {
      flex: 2;
    }
  }

  &__form-radio-group {
    display: flex;
    gap: 20px;
    padding-top: 8px;
  }

  &__form-radio-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;

    input[type="radio"] {
      accent-color: #f37021;
      width: 16px;
      height: 16px;
    }
  }

  &__form-textarea {
    flex: 1;
    min-width: 150px;
    padding: 12px 15px;
    background-color: #5c2525;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    resize: vertical;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus {
      border-color: rgba(255, 255, 255, 0.3);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  &__form-btn {
    padding: 6px 12px;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }
  }

  &__submit-btn {
    display: block;
    width: 100%;
    padding: 12px;
    background-color: #f37021;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-top: 20px;

    &:hover {
      background-color: #d95e12;
    }
  }

  &__form--upload {
    & .gr-page__form-row {
      align-items: flex-start;
    }

    & .gr-page__form-label {
      width: 120px;
      flex-shrink: 0;
      padding-top: 10px;
      box-sizing: border-box;
    }

    & .gr-page__form-textarea {
      flex: 1;
      min-width: 200px;
    }

    & .gr-page__form-textarea-count {
      margin-left: 135px;
    }

    & .gr-page__upload-area {
      flex: 1;
      min-width: 200px;
    }

    & .gr-page__form-checkbox {
      margin-top: 10px;
    }

    & .gr-page__form-btn {
      padding: 10px 16px;
      font-size: 12px;
      flex-shrink: 0;
    }
  }

  &__link-accounts {
    background-color: #5c2525;
    border-radius: 4px;
    padding: 20px;
  }

  &__link-accounts-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 15px 0;
  }

  &__link-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px;
    background-color: #4d2020;
    border-radius: 4px;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__link-name {
    font-size: 14px;
    color: #ffffff;
  }

  &__link-check {
    color: #4caf50;
    font-weight: bold;
  }

  &__link-btn {
    padding: 6px 16px;
    background-color: #f37021;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #d95e12;
    }

    &--connected {
      background-color: #5c3a3a;
      color: rgba(255, 255, 255, 0.7);

      &:hover {
        background-color: #6b4a4a;
      }
    }
  }

  &__subscription-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #5c2525;
    border-radius: 4px;
    padding: 25px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 15px;
  }

  &__subscription-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  &__subscription-plan {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
  }

  &__subscription-price {
    font-size: 24px;
    font-weight: 700;
    color: #f37021;
  }

  &__subscription-billing {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
  }

  &__subscription-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }

  &__subscription-badge {
    padding: 4px 12px;
    background-color: #4caf50;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
  }

  &__subscription-expire {
    font-size: 13px;
    color: #4caf50;
    font-weight: 500;
  }

  &__subscription-card--vip {
    background: linear-gradient(135deg, #5c2525 0%, #4a1a1a 100%);
    border: 1px solid rgba(243, 112, 33, 0.3);
  }

  &__subscription-card--normal {
    .gr-page__subscription-plan {
      color: rgba(255, 255, 255, 0.6) !important;
    }
  }

  &__subscription-benefits {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__subscription-benefit {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
  }

  &__feature-icon {
    width: 20px;
    height: 20px;
    color: #d4a04a;
    flex-shrink: 0;
    margin-top: 2px;
  }

  &__subscription-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;

    &--vip {
      background-color: #4caf50;
      color: #ffffff;

      &:hover {
        background-color: #43a047;
      }
    }

    &--normal {
      background-color: #f37021;
      color: #ffffff;

      &:hover {
        background-color: #d95e12;
      }
    }
  }

  &__subscription-features {
    background-color: #5c2525;
    border-radius: 4px;
    padding: 20px;

    h3 {
      font-size: 14px;
      font-weight: 600;
      color: #f37021;
      margin: 0 0 15px 0;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        padding: 12px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: flex-start;
        gap: 12px;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  &__favorites-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.8;
    margin-bottom: 25px;

    p {
      margin: 0 0 8px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__favorites-container {
    display: flex;
    gap: 20px;
  }

  &__favorites-column {
    flex: 1;
    background-color: #5c2525;
    border-radius: 4px;
    overflow: hidden;
  }

  &__favorites-column-title {
    padding: 12px 15px;
    background-color: #4d2020;
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__favorites-list {
    max-height: 300px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__favorites-empty {
    text-align: center;
    padding: 40px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
  }

  &__favorites-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &__favorites-item-img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    object-fit: cover;
  }

  &__favorites-item-name {
    flex: 1;
    font-size: 13px;
    color: #ffffff;
  }

  &__favorites-item-num {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
    background-color: rgba(255, 255, 255, 0.1);
    padding: 4px 8px;
    border-radius: 4px;
  }

  &__settings-item {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  &__settings-label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    flex: 1;
  }

  &__settings-select {
    padding: 10px 15px;
    background-color: #5c2525;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
    min-width: 200px;
  }

  &__settings-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
    margin: 0 0 20px 0;
  }

  &__settings-hardware {
    background-color: #5c2525;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
  }

  &__hardware-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
  }

  &__hardware-check {
    color: #4caf50;
    font-weight: bold;
  }

  &__settings-more,
  &__settings-note {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 0 8px 0;
  }

  &__email-settings {
    margin-bottom: 20px;
  }

  &__email-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #5c2525;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 15px;
    gap: 20px;
    flex-wrap: wrap;
  }

  &__email-info {
    flex: 1;
  }

  &__email-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 8px 0;
  }

  &__email-desc {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
    margin: 0;
  }

  &__email-toggle {
    display: flex;
    gap: 5px;
  }

  &__toggle-btn {
    padding: 6px 16px;
    background-color: #5c3a3a;
    border: none;
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: #6b4a4a;
    }

    &--on {
      background-color: #f37021;
      color: #ffffff;
    }
  }

  &__privacy-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.8;

    p {
      margin: 0 0 10px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__devices-table {
    background-color: #5c2525;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 20px;
  }

  &__devices-header {
    display: flex;
    padding: 12px 15px;
    background-color: #4d2020;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__devices-row {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    &:last-child {
      border-bottom: none;
    }
  }

  &__devices-col {
    flex: 1;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);

    &:first-child {
      flex: 0.5;
    }
  }

  &__devices-btn {
    padding: 6px 12px;
    background-color: #5c3a3a;
    border: none;
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #6b4a4a;
      color: #ffffff;
    }
  }

  &__required {
    color: #f37021;
  }

  &__verify-card {
    background-color: rgba(243, 112, 33, 0.15);
    border-radius: 8px;
    padding: 25px;
    text-align: center;
    margin-bottom: 25px;
    border: 1px solid rgba(243, 112, 33, 0.3);
  }

  &__verify-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 15px auto;
    background-color: rgba(243, 112, 33, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #f37021;
  }

  &__verify-title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 10px 0;
  }

  &__verify-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    line-height: 1.6;
  }

  &__form-btn--primary {
    background-color: #f37021;
    color: #ffffff;
    border-color: #f37021;

    &:hover {
      background-color: #d95e12;
      border-color: #d95e12;
    }

    &:disabled {
      background-color: #5c3a3a;
      border-color: #5c3a3a;
      cursor: not-allowed;
      opacity: 0.7;
    }
  }

  &__form-checkbox {
    width: 16px;
    height: 16px;
    accent-color: #f37021;
    margin-right: 10px;
    margin-top: 10px;
  }

  &__form-checkbox-label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    padding-top: 8px;
  }

  &__form-link {
    color: #f37021;
    text-decoration: underline;

    &:hover {
      color: #ff8c42;
    }
  }

  &__form-textarea {
    flex: 1;
    min-width: 200px;
    padding: 12px 15px;
    background-color: #5c2525;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    resize: vertical;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus {
      border-color: rgba(255, 255, 255, 0.3);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  &__form-textarea-count {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 5px;
    margin-left: 135px;
  }

  &__form-input--select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='rgba(255,255,255,0.6)' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 12px center;
    background-repeat: no-repeat;
    background-size: 16px;
    padding-right: 40px;
    cursor: pointer;
  }

  &__hidden-input {
    display: none;
  }

  &__upload-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    gap: 8px;
  }

  &__upload-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    &--active {
      .gr-page__upload-step-num {
        background-color: #f37021;
        color: #ffffff;
      }

      .gr-page__upload-step-text {
        color: #ffffff;
      }
    }
  }

  &__upload-step-num {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #5c3a3a;
    color: rgba(255, 255, 255, 0.5);
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  &__upload-step-text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    transition: color 0.2s;
  }

  &__upload-step-line {
    width: 60px;
    height: 2px;
    background-color: #5c3a3a;
  }

  &__upload-area {
    flex: 1;
    min-width: 200px;
    height: 150px;
    border: 2px dashed rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.25s;
    background-color: rgba(255, 255, 255, 0.03);
    overflow: hidden;

    &:hover {
      border-color: #f37021;
      background-color: rgba(243, 112, 33, 0.05);
    }

    &--audio {
      height: 140px;
    }
  }

  &__upload-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: rgba(255, 255, 255, 0.6);

    svg {
      width: 40px;
      height: 40px;
    }

    span {
      font-size: 14px;

      &:last-child {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }

  &__upload-tip {
    font-size: 11px !important;
    color: rgba(255, 255, 255, 0.4) !important;
  }

  &__upload-audio-info {
    display: flex;
    align-items: center;
    gap: 12px;
    color: rgba(255, 255, 255, 0.8);

    svg {
      width: 28px;
      height: 28px;
      color: #f37021;
    }

    span {
      font-size: 13px;
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__upload-progress {
    background-color: #5c2525;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 25px;
  }

  &__upload-progress-bar {
    height: 8px;
    background-color: #4d2020;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 12px;
  }

  &__upload-progress-fill {
    height: 100%;
    background-color: #f37021;
    border-radius: 4px;
    transition: width 0.3s ease;
  }

  &__upload-progress-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
    text-align: center;
  }

  &__modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
  }

  &__modal {
    background-color: #6b2a2a;
    border-radius: 12px;
    width: 90%;
    max-width: 420px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    animation: modalFadeIn 0.3s ease;
  }

  &__modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__modal-title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
  }

  &__modal-close {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;
    transition: all 0.2s;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__modal-body {
    padding: 30px 24px;
    text-align: center;
  }

  &__modal-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 20px auto;
    background-color: rgba(243, 112, 33, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f37021;
    animation: iconSpin 1s linear infinite;

    svg {
      width: 28px;
      height: 28px;
    }

    &--success {
      animation: none;
      background-color: rgba(76, 175, 80, 0.15);
      color: #4caf50;
    }
  }

  &__modal-text {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9);
    margin: 0 0 16px 0;

    &--success {
      font-size: 20px;
      font-weight: 600;
      color: #4caf50;
    }
  }

  &__modal-subtext {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
    line-height: 1.6;
  }

  &__modal-progress-bar {
    height: 8px;
    background-color: #5c2525;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
  }

  &__modal-progress-fill {
    height: 100%;
    background-color: #f37021;
    border-radius: 4px;
    transition: width 0.3s ease;
  }

  &__modal-progress-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
  }

  &__modal-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
  }

  &__modal-btn {
    padding: 12px 32px;
    background-color: #f37021;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #d95e12;
    }
  }

  @media (max-width: 768px) {
    &__container {
      padding: 20px 15px;
    }

    &__title {
      font-size: 22px;
    }

    &__tab {
      padding: 12px 12px;
      font-size: 12px;
    }

    &__content {
      padding: 20px;
    }

    &__form--upload {
      & .gr-page__form-row {
        flex-direction: column;
        align-items: flex-start;
      }

      & .gr-page__form-label {
        width: 100%;
        padding-top: 0;
        margin-bottom: 5px;
      }

      & .gr-page__form-input {
        width: 100%;
      }

      & .gr-page__form-textarea {
        width: 100%;
      }

      & .gr-page__form-textarea-count {
        margin-left: 0;
      }

      & .gr-page__upload-area {
        width: 100%;
      }
    }

    &__favorites-container {
      flex-direction: column;
    }

    &__email-item {
      flex-direction: column;
    }

    &__email-toggle {
      width: 100%;
      justify-content: flex-start;
    }
  }

  &__modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
  }

  &__modal {
    background-color: #6b2a2a;
    border-radius: 12px;
    width: 90%;
    max-width: 420px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  }

  &__modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__modal-title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
  }

  &__modal-close {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;
    transition: all 0.2s;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__modal-body {
    padding: 30px 24px;
    text-align: center;
  }

  &__modal-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 20px auto;
    background-color: rgba(243, 112, 33, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f37021;
    font-size: 30px;

    svg {
      width: 28px;
      height: 28px;
    }

    &--success {
      animation: none;
      background-color: rgba(76, 175, 80, 0.15);
      color: #4caf50;
    }
  }

  &__modal-text {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.9);
    margin: 0 0 16px 0;

    &--success {
      font-size: 20px;
      font-weight: 600;
      color: #4caf50;
    }
  }

  &__modal-subtext {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
    line-height: 1.6;
  }

  &__modal-progress-bar {
    height: 8px;
    background-color: #5c2525;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
  }

  &__modal-progress-fill {
    height: 100%;
    background-color: #f37021;
    border-radius: 4px;
    transition: width 0.3s ease;
  }

  &__modal-progress-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
  }

  &__modal-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
  }

  &__modal-btn {
    padding: 12px 32px;
    background-color: #f37021;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #d95e12;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.gr-page {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>